export default {
  SET_CAROUSELS: 'SET_CAROUSELS',
  UPDATE_IS_CAROUSEL_ACTIVE: 'UPDATE_IS_CAROUSEL_ACTIVE',
  ACTIVATE_CAROUSELS: 'ACTIVATE_CAROUSELS',
};
